module.exports = __webpack_public_path__ + "static/media/graph.0243817f.png";